import React from "react";
import Image from "next/image";
// import { TruncatedText } from '../../layouts/LayoutRelatedSubjects/LayoutRelatedSubjects'

export interface featuredPost {
  image: {
    src: string;
    alt: string;
  };
  header: string;
  description: string;
  destination: string;
}
export interface FeaturePostsProps {
  featuredPosts: featuredPost[];
  wrapImageListItem: (item: featuredPost, index: number, children: React.ReactNode) => React.ReactNode | React.ReactElement;
  componentImagePriority?: "high" | "auto" | "low";
}
export const FeaturedPosts = ({
  featuredPosts,
  wrapImageListItem,
  componentImagePriority
}: FeaturePostsProps) => {
  // const { width } = useScreenSize()
  return featuredPosts?.length > 0 && featuredPosts?.map((item, index) => {
    const wrappedItem = wrapImageListItem(item, index, <>
          {item?.image?.src && <Image className="w-24 h-24 mr-6 rounded-lg object-cover max-sm:w-16 max-sm:h-16 max-sm:mr-5" src={item?.image?.src} alt={item?.image?.alt || ""} loading="lazy" width={88} height={88} fetchPriority={componentImagePriority} />}
          <div>
            <h3 className="text-gray-m9 text-base font-semibold leading-normal pb-2.5 t2-dark:text-white">
              {item?.header || ""}
            </h3>
            <div className="text-gray-m9 text-base font-light leading-normal w-full overflow-hidden text-ellipsis t2-dark:text-white">
              {item?.description}
            </div>
          </div>
        </>);
    return wrappedItem;
  });
};